import React, { useState, useEffect } from 'react';
import { BsPencil, BsDownload } from 'react-icons/bs';
import { IoMdCopy } from 'react-icons/io';
import { FiTrash } from 'react-icons/fi';
import { MdOutlineDriveFileMove } from 'react-icons/md';
import { connect } from 'react-redux';
import s from './style.css';
import { vault, app } from '../../actions';
import { InputModal } from '../index';
import SettingsItem from '../SettingsItem';
import { formatBytes } from '../../utils';
const ContextMenu = (props) => {
    const { x, y, onItemClick, item, type } = props;
    const [modalVisible, setModalVisible] = useState(false);
    const [fileName, setFileName] = useState(item.name);
    useEffect(() => {
        if (props.renaming && props.renaming.uriKey === props.item.uriKey) {
            setModalVisible(true);
        }
    }, [props.renaming]);
    const executeDownload = (givenUri) => {
        const a = document.createElement('a');
        a.href = givenUri || props.uri;
        a.download = item.name.replace(/\s+\S*$/, '');
        a.click();
    };
    const downloadFile = async () => {
        if ('isPhoto' in item && item.isPhoto) {
            const testImage = new Image();
            testImage.src = props.heicUri || props.uri;
            testImage.onerror = function () {
                props.cacheVaultFile({ file: item, isPreview: false, callback: executeDownload });
            };
            testImage.onload = function () {
                executeDownload();
            };
        }
        else {
            props.cacheVaultFile({ file: item, isPreview: false, callback: executeDownload });
        }
    };
    let fileActions = [
        {
            text: 'Rename',
            icon: React.createElement(BsPencil, { color: '#0F0F28' }),
            onClick: () => {
                props.renamingFile(props.item);
            },
        },
        {
            text: 'Move',
            icon: React.createElement(MdOutlineDriveFileMove, { color: '#0F0F28' }),
            onClick: () => {
                props.movingFile(props.item);
                onItemClick();
            },
        },
        {
            text: 'Download',
            icon: React.createElement(BsDownload, { color: '#0F0F28' }),
            onClick: () => {
                downloadFile();
                onItemClick();
            },
        },
    ];
    if (props.inFileView) {
        fileActions = fileActions.filter((action) => action.text !== 'Move');
    }
    if ('isFolder' in props.item && props.item.isFolder) {
        fileActions = fileActions.filter((action) => action.text !== 'Download');
    }
    const noteActions = [
        {
            text: 'Copy',
            icon: React.createElement(IoMdCopy, { color: '#0F0F28' }),
            onClick: () => {
                navigator.clipboard.writeText(item.text);
                onItemClick();
            },
        },
    ];
    const commonActions = [
        {
            text: 'Delete',
            danger: true,
            icon: React.createElement(FiTrash, { color: 'red' }),
            onClick: () => {
                const confirmed = window.confirm(`Are you sure you want to delete this ${type}?`);
                if (confirmed)
                    props.deleteItem(item, type);
                onItemClick();
            },
        },
    ];
    let actions;
    if (type === 'file') {
        actions = fileActions;
    }
    else {
        actions = noteActions;
    }
    actions = actions.concat(commonActions);
    return (React.createElement("div", { className: s.menuContainer, style: { top: y, left: x } },
        React.createElement(InputModal, { value: fileName, visible: modalVisible, setVisible: setModalVisible, title: 'Renaming File', doneText: 'Rename', onChange: (e) => setFileName(e.target.value), cancel: () => props.cancelRenaming(), done: () => {
                if (fileName.length === 0) {
                    alert("File name can't be empty");
                }
                else {
                    props.cancelRenaming();
                    setModalVisible(false);
                    if (fileName !== item.name) {
                        props.renameFile(props.item, fileName);
                    }
                    onItemClick();
                }
            } }),
        type === 'file' && (React.createElement("div", { className: s.titleContainer },
            React.createElement("p", { className: s.name }, props.item.name),
            'isFolder' in props.item || (React.createElement("p", { className: s.fileSize }, formatBytes(props.item.fileSize))))),
        actions.map((action) => (React.createElement(SettingsItem, { key: action.text, icon: action.icon, text: action.text, onClick: action.onClick, danger: action.danger })))));
};
const mapStateToProps = (state, ownProps) => {
    return {
        currentFolder: state.appTemp.folderStack[state.appTemp.folderStack.length - 1],
        uri: state.vaultCache[ownProps.item.uriKey]
            ? state.vaultCache[ownProps.item.uriKey].uri
            : null,
        heicUri: state.vaultCache[`${ownProps.item.uriKey}-heic`]
            ? state.vaultCache[`${ownProps.item.uriKey}-heic`].uri
            : null,
        renaming: state.appTemp.renamingFile,
    };
};
const connector = connect(mapStateToProps, { ...vault, ...app });
export default connector(ContextMenu);
